export const DEFAULT_DOCUMENT = 'default';
export const DEFAULT_INDEX = 1;
export const DOCUMENT_MODE = 'document';
export const WHITE_MODE = 'whiteboard';
export const VOD_MODE = 'vod';
export const WORKBOOK_LIST = [DOCUMENT_MODE, WHITE_MODE];
